export const USER_FIELD_INFO_TYPES = [
  { label: 'Employee Information', value: 'employeeInformation' },
  { label: 'Primary Organization', value: 'primaryOrganization' },
  { label: 'Custom Attributes', value: 'customAttributes' },
];

export const DRIVE_FIELD_INFO_TYPES = [
  { label: 'File Type', value: 'fileType' },
  { label: 'File Size', value: 'fileSize' },
  { label: 'File Sharing', value: 'fileSharing' },
  { label: 'Employee Information', value: 'employeeInformation' },
];

export const BOOLEAN_SHARE_FIELD_NAMES = [
  'fileSharedToUserExternalToDomain',
  'fileSharedToUserInternalToDomain',
  'fileIsSharedPublic',
];

export const GROUP_FIELD_INFO_TYPES = [
  { label: 'Group Name', value: 'groupName' },
  { label: 'Member Count', value: 'memberCount' },
];

export const CALENDAR_FIELD_INFO_TYPES = [
  { label: 'Calendar Sharing', value: 'calendarSharing' },
];

export const OPERATORS = [
  { label: 'contains', value: 'contains' },
  { label: 'equals', value: 'equals' },
  { label: 'does not contain', value: 'notContains' },
  { label: 'does not equal', value: 'notEquals' },
  { label: 'starts with', value: 'startsWith' },
  { label: 'ends with', value: 'endsWith' },
];
